// Roster of player display names seen in this world (from presence, world ops, and bodies), persisted to
// localStorage so it survives reloads. Powers the add-user / give-to-player pickers so you never have to
// hand-type a username (owner: typing weird usernames is a nightmare). Names only -- no other state.

const KEY = 'oxide.seenPlayers';

function load(): Set<string> {
  try { const r = localStorage.getItem(KEY); return new Set(r ? (JSON.parse(r) as string[]) : []); }
  catch { return new Set(); }
}

let seen = load();

function persist(): void {
  try { localStorage.setItem(KEY, JSON.stringify([...seen])); } catch { /* storage full/blocked */ }
}

// Record a name as seen. Ignores blanks + the single-player 'local' sentinel. Cheap + deduped.
export function noteSeenPlayer(name: string | undefined | null): void {
  if (!name) return;
  const n = name.trim();
  if (!n || n === 'local') return;
  if (!seen.has(n)) { seen.add(n); persist(); }
}

// All seen names, alphabetical. Pass a query to filter (case-insensitive substring).
export function seenPlayers(query = ''): string[] {
  const q = query.trim().toLowerCase();
  const all = [...seen].sort((a, b) => a.localeCompare(b));
  return q ? all.filter((n) => n.toLowerCase().includes(q)) : all;
}
